import React from 'react';
import { connect } from 'react-redux';
import Cart from '../Cart/Cart';
import Product from './Product/Product';

const Products = ({ products }) => {
  return (
    <div className="bg-gray-50 h-full md:h-screen">
      <div className="grid place-items-center">
        <h1 className="text-gray-900 font-bold text-3xl p-10 underline decoration-purple-500 decoration-4 underline-offset-8 mb-4">
          Shopping Cart
        </h1>
      </div>
      <div className="grid grid-cols-12 gap-2">
        {/* product */}
        {products.map((product) => (
          <Product product={product} key={product.id} />
        ))}

        <Cart />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    products: state.shop.products,
  };
};

export default connect(mapStateToProps)(Products);
